import React , { Component } from 'react';
import HeaderMenu from './headerMenu';
import HeaderBanner from './headerBanner';
import HeaderAnnounce from './headerAnnounce';
import globalStyle from '../../styles/globalStyle';
import PropTypes from 'prop-types';
import { Divider } from "antd";
import SearchBox from '../../common/SearchBox/SearchBox';
import styles from './header.module.css';
import {withRouter} from 'react-router';

class Header extends Component{

    render(){
        return(
            <div style={{background: '#ffffff', display: 'flex', flexDirection: 'column'}}>
                <div style={{...globalStyle.flexCenterRow, background: 'rgba(24,24,24,1)'}}>
                    <div style={{...globalStyle.flexSpaceBetweenRow, color: '#ffffff', height:40, width: 1200}}>
                        <div></div>
                        <div style={{...globalStyle.flexCenterRow}}>
                            <div className={styles.itemText} onClick={()=>{this.props.history.push({pathname:`/about/1/关于我们`});window.scrollTo(0,300)}}>关于我们</div>
                            <Divider type="vertical" style={{margin: '0 16px'}}/>
                            <div className={styles.itemText} onClick={()=>{this.props.history.push('/recruitment#contact-us')}}>联系我们</div>
                            <Divider type="vertical" style={{margin: '0 16px'}}/>
                            <div className={styles.itemText} onClick={()=>{this.props.history.push({pathname:`/about/4/荣誉资质`});window.scrollTo(0,300)}}>荣誉资质</div>
                        </div>
                    </div>
                </div>
                <div style={{...globalStyle.flexCenterRow, padding: '8px 0'}}>
                    <div style={{...globalStyle.flexSpaceBetweenRow, width: 1200}}>
                        <div style={{...globalStyle.flexCenterRow}}>
                            <img src={require('../../images/logo.png')}/>
                            <div style={{...globalStyle.flexSpaceBetweenColumn, padding: 24}}>
                                <div style={{width: '100%', textAlign: 'left', fontSize: 24, fontWeight: 'bold', color: '#000000'}}>北京经纬通达管理咨询有限公司</div>
                                {/* <div style={{width: '100%', textAlign: 'left', fontSize: 10}}>BEI JING JING WEI TONG DA MANAGEMENT CONSULTING COMPANY</div> */}
                            </div>
                        </div>
                        <SearchBox />
                        <img src={require('../../images/logo2.png')}/>
                    </div>
                </div>
                <Divider style={{margin: '0'}}/>
                <HeaderMenu currentSelectIndex={this.props.headerMenuSelectIndex}/>
                <HeaderBanner />
                <HeaderAnnounce />
            </div>
        );

    }
}

Header.propTypes={
   headerMenuSelectIndex:PropTypes.number.isRequired,
}

export default withRouter(Header);
